module.exports = __webpack_public_path__ + "static/img/jingji1.35c00658.png";